import { createAction } from '../types';

import * as Actions from './actionTypes';

export const optionsToggle = ({ option }) => createAction(Actions.OPTIONS_TOGGLE, { option });
